module.exports = __webpack_public_path__ + "static/media/MenuX-Logo.0701db53.svg";